module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/why_we_are_doing_this-e1d3808a156ace90a009e1ccaacfeeaa.svg";